<div class="cutoff-timer-editor" [formGroup]="optionsForm">
  <div class="cutoff-timer-editor__field">
    <label class="cutoff-timer-editor__field-label">Position</label>
    <pdq-radio-group formControlName="position">
      <pdq-radio-button [value]="cutoffTimerPosition.LINKED" text="Linked to delivery date"></pdq-radio-button>
      <pdq-radio-button [value]="cutoffTimerPosition.STANDALONE" text="Standalone"></pdq-radio-button>
    </pdq-radio-group>
  </div>

  <div class="cutoff-timer-editor__field">
    <label class="cutoff-timer-editor__field-label">Display message</label>
    <rich-textarea
      [initialContent]="initialDisplayMessage"
      placeholder=""
      [disabledFormats]="['list:ordered']"
      (contentChange)="onDisplayMessageChange($event)">
    </rich-textarea>
    <small class="cutoff-timer-editor__helper">
      Dynamic fields available. Use <code>&#123;time_left&#125;</code> for the live timer.
    </small>
  </div>

  @if (isStandalone) {
    <div class="cutoff-timer-editor__field">
      <label class="cutoff-timer-editor__field-label">Icon</label>
      <pdq-iconpicker
        [presetIconUrls]="presetIconUrls"
        [iconUrl]="iconUrlValue"
        [customIconUrl]="customIconUrlValue"
        (iconUrlChange)="onIconUrlChange($event)"
        (uploadCustomRequested)="onUploadCustomIcon()"
        (removeCustomRequested)="onRemoveCustomIcon()">
      </pdq-iconpicker>
    </div>

    <div class="cutoff-timer-editor__field">
      <label class="cutoff-timer-editor__field-label">Background banner color</label>
      <pdq-input-color
        [control]="optionsForm.get('backgroundColor')"
        [formControl]="optionsForm.get('backgroundColor')"
        [clearable]="true"
        clearTooltip="Remove banner"
        (cleared)="onClearBackgroundColor()"
        placeholder="No background color"
        label=""></pdq-input-color>
      <small class="cutoff-timer-editor__helper"
        >Clear the color (X) to render the timer with no background banner.</small
      >
    </div>
  }
</div>
